var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 1244 c-44 -31 -31 -52 193 -316 l214 -253 1 -172 c0 -94 3 -179 6 -188 8 -20 235 -135 268 -135 37 0 49 24 50 98 l1 67 -52 3 c-42 2 -53 0 -53 -12 0 -13 -10 -11 -55 11 l-55 27 0 168 0 168 -82 97 c-45 54 -128 153 -186 221 l-104 122 422 0 c467 0 431 5 376 -57 l-19 -23 70 0 c69 0 71 1 106 39 58 65 69 85 58 113 -5 14 -17 28 -26 32 -9 3 -263 6 -564 6 -478 0 -549 -2 -569 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 1018 c-13 -13 -56 -87 -95 -164 l-71 -141 0 -117 c0 -127 12 -172 51 -200 21 -14 65 -16 362 -16 l339 0 34 34 34 34 0 136 0 136 -70 139 c-40 80 -80 148 -96 160 -25 20 -38 21 -245 21 -212 0 -219 -1 -243 -22z m501 -153 c29 -55 52 -103 53 -107 0 -5 -140 -8 -310 -8 l-310 0 55 110 55 110 203 -2 202 -3 52 -100z m81 -289 c2 -64 -1 -103 -9 -112 -9 -11 -69 -14 -330 -14 -304 0 -319 1 -329 19 -11 22 -14 194 -3 204 4 4 155 6 337 5 l331 -3 3 -99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 584 c-10 -9 -15 -23 -12 -31 3 -8 6 -17 6 -19 0 -2 11 -4 25 -4 29 0 43 25 28 48 -14 23 -29 25 -47 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956 584 c-10 -9 -15 -23 -12 -31 3 -8 6 -17 6 -19 0 -2 11 -4 25 -4 29 0 43 25 28 48 -14 23 -29 25 -47 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterLocal);
export default __webpack_public_path__ + "static/media/filter-local.ad6c91c976f8eb40d8890eb180e8d7d4.svg";
export { ForwardRef as ReactComponent };